module.exports = __webpack_public_path__ + "media/images/icons/icon-indigo-check-2af58efa717ce11e1b95de1b4c82bcef.png";